module.exports = __webpack_public_path__ + "static/img/loading.431b7fa.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new/loading.gif
// module id = 6+0O
// module chunks = 2